import React, { memo } from 'react';
import { StackDivider, VStack } from '@chakra-ui/react';
import { ContentCard } from '@olo-web/components/atoms/ContentCard';
import { CheckoutPaymentMethod } from './CheckoutPaymentMethod';
import { GiftCard } from '../GiftCard';
import { VerifyCreditCardButton } from '../VerifyCreditCardButton';
import { useIsOrderButtonHidden } from '../common/hooks/useIsOrderButtonHidden';
import { usePaymentMethodValues } from '@olo-web/domain/payments/hooks';
import { useMerchantOrderTypeDetails } from '@domain/merchants/queries/useMerchantOrderTypeDetails';

interface Props {
  isDisabled?: boolean;
  shouldShowPaymentMethod: boolean;
  shouldShowGiftCard: boolean;
  shouldShowContinueButton?: boolean;
  showEmailField: boolean;
  showSignInButton?: boolean;
}

export const CheckoutPayment = memo(
  ({
    isDisabled,
    shouldShowPaymentMethod,
    shouldShowGiftCard,
    shouldShowContinueButton,
    showEmailField,
    showSignInButton = true,
  }: Props) => {
    const isOrderButtonHidden = useIsOrderButtonHidden();
    const { order } = usePaymentMethodValues();
    const { data: orderTypeDetails } = useMerchantOrderTypeDetails();

    const showContinueToTip =
      isOrderButtonHidden &&
      Number(order?.balanceDueAmount || '0') > 0 &&
      orderTypeDetails?.tippable;
    return (
      <ContentCard title="Payment" isDisabled={isDisabled}>
        <VStack
          justifyContent="flex-start"
          alignItems="flex-start"
          divider={<StackDivider />}
          spacing={{ base: 4, md: 6 }}
          w="100%"
        >
          {shouldShowPaymentMethod && (
            <CheckoutPaymentMethod
              showEmailField={showEmailField}
              showSignInButton={showSignInButton}
            />
          )}
          {shouldShowGiftCard && (
            <GiftCard accessibilityProps={{ role: 'status', 'aria-live': 'polite' }} />
          )}
        </VStack>
        {shouldShowContinueButton && (
          <VerifyCreditCardButton>{`Continue ${
            showContinueToTip ? 'to tip selection' : ''
          }`}</VerifyCreditCardButton>
        )}
      </ContentCard>
    );
  }
);
